export default __webpack_public_path__ + "static/media/561.5f8b18bc.jpg";